<template>
  <el-dialog :title="title" v-model="show" size="full">
    <div v-loading="loading" :element-loading-text="isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'">
      <el-row>
        <el-col :span=8>
          <el-form ref="hInfo1" :model="hInfo1" label-width="120px">
            <el-form-item label="pGuid">
              <el-input v-model="hInfo1.pGuid" placeholder="题目guid"></el-input>
            </el-form-item>
            <el-form-item label="标题">
              <el-input v-model="hInfo1.title" placeholder="标题，如205题提示一、二等"></el-input>
            </el-form-item>
            <el-form-item label="提示级别">
              <el-input v-model="hInfo1.hLevel" placeholder="提示级别，正整数"></el-input>
            </el-form-item>
            <el-form-item >
              <el-button @click="saveHint">保存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span=1>
          &nbsp;
        </el-col>
        <el-col :span=15>
          <el-row>
            <span>提示内容</span>
          </el-row>
          <el-row>
            <div id="standalone-container-jtgc" style="margin: 50px auto;max-width: 100%;">
              <div id="toolbar-container-jtgc">
                <span class="ql-formats">
                  <select class="ql-font"></select>
                  <select class="ql-size"></select>
                </span>
                <span class="ql-formats">
                  <button class="ql-bold"></button>
                  <button class="ql-italic"></button>
                  <button class="ql-underline"></button>
                  <button class="ql-strike"></button>
                </span>
                <span class="ql-formats">
                  <select class="ql-color"></select>
                  <select class="ql-background"></select>
                </span>
                <span class="ql-formats">
                  <button class="ql-script" value="sub"></button>
                  <button class="ql-script" value="super"></button>
                </span>
                <span class="ql-formats">
                  <button class="ql-header" value="1"></button>
                  <button class="ql-header" value="2"></button>
                  <button class="ql-blockquote"></button>
                  <button class="ql-code-block"></button>
                </span>
                <span class="ql-formats">
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                  <button class="ql-indent" value="-1"></button>
                  <button class="ql-indent" value="+1"></button>
                </span>
                <span class="ql-formats">
                  <button class="ql-direction" value="rtl"></button>
                  <select class="ql-align"></select>
                </span>
                <span class="ql-formats">
                  <button class="ql-link"></button>
                  <button class="ql-image"></button>
                  <button class="ql-video"></button>
                  <button class="ql-formula"></button>
                </span>
                <span class="ql-formats">
                  <button class="ql-clean"></button>
                </span>
              </div>
              <div id="editor-container-jtgc" style="height: 500px;"></div>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
  import { getHintByGuid, addNewHint, updateHintByGuid } from '@/api/api_hint.js'

  export default {
    data () {
      return {
        show: false,
        loading: false,
        tempstr: '',
        guid: '',
        tmguid: '',
        isEditData: false,
        hInfo1: {
          id: 0,
          guid: '',
          pGuid: '',
          hLevel: '',
          content: '',
          title: '',
          date: ''
        },
        quill: null
      }
    },
    computed: {
      title () {
        return `编辑解题提示-${this.isEditData === true ? '修改' : '新增'}`
      }
    },
    watch: {
      show: function (val) {
        if (val) {
          this.markDown()
        }
        this.hInfo1.pGuid = this.tmguid
      }
    },
    methods: {
      markDown () {
        setTimeout(() => {
          if (!this.quill) {
            this.quill = new window.Quill('#editor-container-jtgc', {
              modules: {
                formula: true,
                syntax: true,
                toolbar: {
                  container: '#toolbar-container-jtgc',
                  handlers: {
                    image: this.imageHandler
                  }
                }
              },
              placeholder: 'Compose an epic...',
              theme: 'snow'
            })
          }
          if (this.isEditData === true) {
            this.loadData()
          }
        }, 1000)
      },
      imageHandler () {
        console.log('65')
        var range = this.quill.getSelection()
        var value = prompt('What is the image URL')
        this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER)
      },
      closeDlg () {
        this.show = false
      },
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '解题提示',
          message: msg,
          type: type
        })
      },
      saveHint () {
        this.hInfo1.content = JSON.stringify(this.quill.getContents())
        console.log('save hint')
        if (this.isEditData === false) {
          // 新增解题提示
          addNewHint(this.hInfo1).then((res) => {
            if (res.data) {
              if (res.data.isOk === true) {
                this.showMsg('添加解题提示成功。', 'info')
              } else {
                this.showMsg('添加解题提示失败。', 'info')
              }
            } else {
              this.showMsg('添加解题提示不成功。', 'info')
            }
          }).catch(err => {
            this.showMsg(`添加解题提示失败。${err}`)
          })
        } else {
          // 修改解题方法
          updateHintByGuid(this.hInfo1).then((res) => {
            if (res.data) {
              if (res.data.isOk === true) {
                this.showMsg('修改解题提示成功。', 'info')
              } else {
                this.showMsg('修改解题提示失败。', 'info')
              }
            } else {
              this.showMsg('修改解题提示不成功。', 'info')
            }
          }).catch(err => {
            this.showMsg(`修改解题提示失败。${err}`)
          })
        }
      },
      loadData () {
        // 加载已有解题提示，用于修改
        if (this.isEditData === true) {
          this.loading = true
          getHintByGuid(this.guid).then((res) => {
            let data = res.data
            if (data.isOk) {
              this.hInfo1 = data.data[0]
              let tm = JSON.parse(this.hInfo1.content)
              console.log(tm.ops)
              if (this.quill) {
                this.quill.setContents(tm.ops)
                this.quill.enable(true)
              } else {
                console.log('quill初始化失败。')
              }
            } else {
              this.showMsg('获取解题提示失败，请关闭修改对话框后重新再试！')
            }
            this.loading = false
          }).catch((err) => {
            this.showMsg(err)
            this.loading = false
          })
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// main.vue?53945046